// extracted by mini-css-extract-plugin
module.exports = {"modalFooter":"ShipToEditingModal_modalFooter__W6fCC","modalContainer":"ShipToEditingModal_modalContainer__vwe4f","row":"ShipToEditingModal_row__YbRce"};